import { Component, OnInit, ViewChild } from '@angular/core';
import { AccountService } from '../../services/account.service';
import { DirectoryService } from "../../services/directory.service";
import { TranslateService } from '@ngx-translate/core';
import { Router } from '@angular/router';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { IDirectoryUserBlockInn, IRationalizatorRegistration, IRatsorgRegistration, IUserShortDto } from '../../models/domain';
import { Observable } from 'rxjs/internal/Observable';
import { PhoneInputComponent } from '../../module/phone-input/phone-input.component';
import { debounceTime } from 'rxjs/operators';
import { switchMap } from 'rxjs/internal/operators/switchMap';
import { MatOption } from '@angular/material/core';
import { DatePipe } from '@angular/common';
import { MatSelectChange } from '@angular/material/select';
import { Title } from '@angular/platform-browser';
import { CaptchaComponent } from '../../components/captcha/captcha.component';

@Component({
    selector: 'app-rationalizator-registration',
    templateUrl: './rationalizator-registration.component.html',
    styleUrls: ['./rationalizator-registration.component.css']
})
export class RationalizatorRegistrationComponent implements OnInit {
    ratForm: FormGroup;
    regInfo: IRationalizatorRegistration;
    blocks: Observable<IDirectoryUserBlockInn[]>;
    ratsorgs: IUserShortDto[];
    ratsorg: IUserShortDto = { id: 0, fullName: '', firstName: '', lastName: '', middleName: '' };
    blockValue: string = ' ';
    hideFileInput: boolean = true;


    validFIO: boolean = false;
    validInn: boolean = false;
    validBlock: boolean = false;
    validEmail: boolean = false;
    validPhone: boolean = false;
    validRatsorg: boolean = false;
    validAdmin: boolean = false;
    validbirthdate: boolean = false;
    validUserAgreement: boolean = false;
    validPersonalData: boolean = false;
    lockSubmitButton: boolean = false;
    invalidCaptcha: boolean = false;
    dateNow = new Date();
    enableRatsorgSelector: boolean = true;

    selectedFiles: FileList;
    public captchaCode: string;
    private _catchaValidationError: string;

    @ViewChild(PhoneInputComponent, { static: true }) phoneInputComponent: PhoneInputComponent;
    @ViewChild('captchaComponent') captchaComponent: CaptchaComponent;

    constructor(
        private accountService: AccountService,
        private directoryService: DirectoryService,
        private _translateService: TranslateService,
        private router: Router,
        private datePipe: DatePipe,
        private title: Title) {
    }

    ngOnInit(): void {
        this.initForm();
        this._initTranslations();
        this.title.setTitle('Регистрация рационализатора')
        this.blocks = this.ratForm.controls["userblockInput"].valueChanges.pipe(
            debounceTime(500),
            switchMap(val => {
                return this.directoryService.getUserBlocks(val || '')
            }),
        );
    }

    private _initTranslations() {
        this._translateService.get(
            [
                'Common.CaptchaValidationError'
            ])
            .subscribe(
                result => {
                    this._catchaValidationError = result['Common.CaptchaValidationError'];
                });
    }

    initForm() {
        this.ratForm = new FormGroup({
            lastName: new FormControl('', Validators.required),
            firstName: new FormControl('', Validators.required),
            middleName: new FormControl('', Validators.required),
            Inn: new FormControl('', Validators.required),
            birthDate: new FormControl('', Validators.required),
            email: new FormControl('', [Validators.required, Validators.email]),
            userAgreement: new FormControl(false, Validators.requiredTrue),
            personalData: new FormControl(false, Validators.requiredTrue),
            userblockInput: new FormControl('', Validators.required),
        })
    }

    displayBlockName(block: IDirectoryUserBlockInn): string {
        return block.name;
    }

    onBlockSelected(option: MatOption) {
        var value: IDirectoryUserBlockInn = option.value;
        this.blockValue = value.id.toString();
        this.ratForm.get('Inn').patchValue(value.inn);
        this.accountService.getRatsorg(value.id).subscribe(res => {
            this.ratsorgs = res;
        })
        this.enableRatsorgSelector = false;
    }

    ratsorgChange(event: MatSelectChange) {
        this.ratsorg = this.ratsorgs.find(r => r.id == event.value);
    }

    birthDateChange() {
        const addYears = (date: Date, years: number): Date => {
            const result = new Date(date);
            result.setFullYear(result.getFullYear() + years);
            return result;
        };
        const checkDate = this.datePipe.transform(addYears(new Date(), -55), 'yyyy-MM-dd')
        this.hideFileInput = this.ratForm.get('birthDate').value >= checkDate;
    }

    submitRegistration() {
        this.lockSubmitButton = true;
        if (this.ratForm.get('birthDate').value > this.datePipe.transform(new Date(), 'yyyy-MM-dd')) {
            alert('Дата рождения не может быть больше текущей!')
            this.ratForm.get('birthDate').patchValue('')
        }
        if (this.ratForm.get('firstName').errors &&
            this.ratForm.get('firstName').hasError('required') ||
            this.ratForm.get('lastName').errors &&
            this.ratForm.get('lastName').hasError('required') ||
            this.ratForm.get('middleName').errors &&
            this.ratForm.get('middleName').hasError('required')) {
            this.validFIO = true;
        } else { this.validFIO = false }
        if (!(this.phoneInputComponent.phoneValueWithRegion.length > 10)) {
            this.validPhone = true;
        } else { this.validPhone = false }
        if (this.ratForm.get('email').errors &&
            this.ratForm.get('email').hasError('required') ||
            this.ratForm.get('email').hasError('email')) {
            this.validEmail = true;
        } else { this.validEmail = false }
        if (this.ratForm.get('userAgreement').errors || this.ratForm.get('userAgreement').hasError('requiredTrue')) {
            this.validUserAgreement = true
        } else { this.validUserAgreement = false }
        if (this.ratForm.get('personalData').errors || this.ratForm.get('personalData').hasError('requiredTrue')) {
            this.validPersonalData = true
        } else { this.validPersonalData = false }
        if (this.ratForm.get('userblockInput').errors || this.ratForm.get('userblockInput').hasError('required')) {
            this.validBlock = true
        } else { this.validBlock = false }
        if (this.ratsorg.id == 0 && this.ratsorg.fullName == '') {
            this.validRatsorg = true
        } else { this.validRatsorg = false }
        if (!this.validInn &&
            !this.validFIO &&
            !this.validPhone &&
            !this.validEmail &&
            !this.validUserAgreement &&
            !this.validPersonalData &&
            !this.validBlock &&
            !this.validRatsorg
            && this.ratForm.valid) {
            this.regInfo = this.ratForm.value
            this.regInfo.phone = this.phoneInputComponent.phoneValueWithRegion
            this.regInfo.captchaCode = this.captchaCode
            this.regInfo.blockId = Number(this.blockValue);
            this.regInfo.adminComment = this.ratsorg.id + "-" + this.ratsorg.fullName
            this.accountService.rationalizatorRegistration(this.regInfo).subscribe(res => {
                if (res.success) {
                    alert('Регистрация прошла успешно')
                    window.location.href = './api/v1/Account/redirect-out'
                }
                else if (res.error == "InvalidCaptcha") {
                    this.invalidCaptcha = true;
                    this.captchaComponent.refreshCaptcha();
                    this.lockSubmitButton = false;
                }
                else if (res.error == "EmailExist") {
                    alert('Такой Email уже используется!')
                    this.lockSubmitButton = false;
                    this.captchaComponent.refreshCaptcha();
                }
                else if (res.error == "LoginExist") {
                    alert('Такой номер телефона уже используется!')
                    this.lockSubmitButton = false;
                    this.captchaComponent.refreshCaptcha();
                }
                else {
                    console.error(res.error)
                    alert('Произошла непредвиденная ошибка. Попробуйте снова.')
                    this.invalidCaptcha = false;
                    this.lockSubmitButton = false;
                    this.captchaComponent.refreshCaptcha();
                }
            })
        } else { this.lockSubmitButton = false; return }
    }
}
